'use client';

import { useRouter } from 'next/navigation';

import { useUpdateUser } from '@website/hooks/useUpdateUser';
import { getOnboardingRedirectPath } from '@website/utils/profileUtils';

/**
 * Switch the current user to the professional role, then route them to the
 * next unfinished onboarding step (or the dashboard when there is none).
 */
export function useBecomeMentor(locale: string, options?: { onSettled?: () => void }) {
  const router = useRouter();
  const onSettled = options?.onSettled;

  const updateUser = useUpdateUser({
    onSuccess: (updatedUser) => {
      onSettled?.();
      const onboardingPath = getOnboardingRedirectPath(updatedUser);
      router.push(`/${locale}${onboardingPath ?? '/dashboard'}`);
    },
    onError: (error) => {
      console.error('Failed to update user role:', error);
      onSettled?.();
    }
  });

  const becomeMentor = (userId: string) => updateUser.mutate({ id: userId, isProfessional: true });

  return { becomeMentor, isPending: updateUser.isPending };
}
